import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { enums, enumValue } from '~/util';

export const useGetNotes = () => {
    const services = React.useContext(ServicesContext);

    const getNotes = useCallback(
        async (
            id: number,
            type: string,
            actions?: boolean | string[] | null
        ): Promise<NoteType[]> => {
            let route = `/api/notes?${type}=${id}`;

            if (typeof actions !== 'undefined' && actions !== null) {
                if (Array.isArray(actions)) {
                    actions.forEach((x) => {
                        route += `&action[]=${x}`;
                    });
                } else if (actions === true) {
                    route += '&exists[action]=true';
                } else {
                    route += '&exists[action]=false';
                    // Omit task notes from any other notes feed
                    if (type !== 'task.id') {
                        route += Object.keys(enums(['note', 'type']))
                            .filter((x) => parseInt(x) !== enumValue(['note', 'type', 'Task Note']))
                            .map((x) => `&type[]=${x}`)
                            .join('');
                    }
                }
            }

            const result: ApiDataResponseType<NoteType[]> = await services.api.call({
                method: 'get',
                url: route,
            });

            return result.data;
        },
        [services.api]
    );

    return getNotes;
};
